import React from 'react';
import { 
  TableCellsIcon, CameraIcon, UserGroupIcon, ClockIcon 
} from '@heroicons/react/24/outline';
import { ViewMode } from './AttendeeFilters';

interface ViewModeTabsProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const ViewModeTabs: React.FC<ViewModeTabsProps> = ({ viewMode, onViewModeChange }) => {
  const tabs = [
    { id: 'pipeline' as ViewMode, label: 'Pipeline', icon: TableCellsIcon },
    { id: 'checkin' as ViewMode, label: 'Check-in', icon: CameraIcon },
    { id: 'source' as ViewMode, label: 'Source', icon: UserGroupIcon },
    { id: 'activity' as ViewMode, label: 'Activity', icon: ClockIcon },
  ];

  return (
    <div className="flex gap-1 p-1 bg-gray-100 rounded-lg mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onViewModeChange(tab.id)}
          className={`flex-1 px-3 py-2 rounded-md font-medium transition-colors flex items-center justify-center gap-2 text-sm ${
            viewMode === tab.id
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          <tab.icon className="h-5 w-5" />
          <span className="hidden sm:inline">{tab.label}</span>
          <span className="sm:hidden">{tab.label.slice(0, 3)}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewModeTabs;